import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ palette }) => ({
  badgeColor: {
    backgroundColor: palette.warning.main,
  },
}));
